import * as css from './AccountVerifyChip.css';
import {useTranslation} from 'react-i18next';
import {Button} from '@tickchak/react-share/app';
import {getStaticImage} from '../../../../../globalVariables/GlobalVariables';
import useNavigationLink from '../../../../../hooks/useNavigationLink';

const accountVerifiedShield = getStaticImage('app/dashboard/accountVerifiedShield.png');
const accountUnverifiedShield = getStaticImage('app/dashboard/accountUnverifiedShield.png');

function AccountVerifyChip({isVerified}: { isVerified?: boolean; }) {
    const {t} = useTranslation('package');
    const verificationPop = useNavigationLink('verificationPop', 'open');

    if(isVerified)
        return (
            <css.verifiedChip data-cy="account-verify-chip">
                <css.verifiedIcon $icon={accountVerifiedShield}/>
                <css.verifiedText>{t('accountVerifiedTitle')}</css.verifiedText>
            </css.verifiedChip>
        );

    return (
        <css.chip data-cy="account-unverify-chip" onClick={() => verificationPop.open()}>
            <css.status>
                <css.illustration $icon={accountUnverifiedShield}/>
                <css.title>{t('unverifiedAccount')}</css.title>
            </css.status>
            <css.actionPill>
                <Button size="chip" variant="subtle" data-cy="account-verify-btn"
                    onClick={() => verificationPop.open()}>{t('accountVerification')}</Button>
            </css.actionPill>
        </css.chip>
    );
}

export default AccountVerifyChip;
